import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useCMS } from '@/hooks/useCMS';

const DEFAULT = {
  hero_label: 'კონტაქტი',
  hero_heading: 'დაგვიკავშირდით',
  hero_subtext: 'ჩვენი გუნდი მზადაა დაგეხმაროთ პროდუქტის შერჩევაში, ტექნიკური კონსულტაციისა და შეკვეთის გაფორმებაში.',
  hero_image: 'https://readdy.ai/api/search-image?query=Modern%20premium%20showroom%20interior%20with%20natural%20stone%20marble%20tiles%20elegant%20warm%20lighting%20architectural%20photography%20wide%20angle%20minimalist%20design&width=1920&height=700&seq=contact-hero-phoenix&orientation=landscape',
  hero_image_alt: 'კონტაქტი',
  info_items: [
    { icon: 'ri-map-pin-2-line', label: 'მისამართი', value: 'გელოვანის ქ. N13, თბილისი',   sub: 'საქართველო, 0186',              href: 'https://maps.google.com/?q=41.7151,44.8271' },
    { icon: 'ri-phone-line',     label: 'ოფისი',     value: '0322 570 505',                  sub: 'ორშ–შაბ: 09:30–19:30',          href: 'tel:+995322570505' },
    { icon: 'ri-smartphone-line',label: 'მობილური',  value: '+995 599 87 20 20',              sub: 'WhatsApp-ზეც ხელმისაწვდომი',    href: 'tel:+995599872020' },
    { icon: 'ri-mail-line',      label: 'ელფოსტა',   value: 'info@phoenix.ge',               sub: 'ვპასუხობთ 24 საათში',           href: 'mailto:info@phoenix.ge' },
  ],
  form_heading: 'შეტყობინების გაგზავნა',
  form_subtext: 'შეავსეთ ფორმა და ჩვენი სპეციალისტი დაგიკავშირდებათ 24 საათის განმავლობაში.',
  form_url: 'https://readdy.ai/api/form/d7nssdlbmnmv4i2ukah0',
  form_label_name: 'სახელი *',
  form_placeholder_name: 'თქვენი სახელი',
  form_label_surname: 'გვარი',
  form_placeholder_surname: 'თქვენი გვარი',
  form_label_email: 'ელფოსტა *',
  form_placeholder_email: 'your@email.com',
  form_label_phone: 'ტელეფონი',
  form_placeholder_phone: '+995 5XX XX XX XX',
  form_label_subject: 'თემა',
  form_subject_placeholder: 'აირჩიეთ თემა',
  form_subject_options: [
    { value: 'product-inquiry', label: 'პროდუქტის შეკითხვა' },
    { value: 'consultation',    label: 'ტექნიკური კონსულტაცია' },
    { value: 'order',           label: 'შეკვეთის გაფორმება' },
    { value: 'delivery',        label: 'მიწოდება' },
    { value: 'complaint',       label: 'საჩივარი / დაბრუნება' },
    { value: 'other',           label: 'სხვა' },
  ],
  form_label_message: 'შეტყობინება *',
  form_placeholder_message: 'გვიამბეთ პროექტის შესახებ...',
  form_btn_label: 'შეტყობინების გაგზავნა',
  form_btn_loading: 'იგზავნება...',
  form_success_title: 'შეტყობინება გაიგზავნა!',
  form_success_text: 'ჩვენი გუნდი მალე დაგიკავშირდებათ.',
  map_embed_url: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2978.5!2d44.8015!3d41.6938!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDHCsDQxJzM3LjciTiA0NMKwNDgnMDUuNCJF!5e0!3m2!1ska!2sge!4v1234567890',
  map_heading: 'ჩვენი შოურუმი',
  map_address: 'გელოვანის ქ. N13, თბილისი',
  map_hours_heading: 'სამუშაო საათები',
  map_hours_label_weekdays: 'ორშაბათი — პარასკევი',
  map_hours_weekdays: '09:30 — 19:30',
  map_hours_label_saturday: 'შაბათი',
  map_hours_saturday: '10:00 — 17:00',
  map_hours_label_sunday: 'კვირა',
  map_hours_sunday: 'დახურულია',
  map_hours_sunday_open: false,
  social_heading: 'სოციალური ქსელები',
  social_links: [
    { icon: 'ri-facebook-fill', href: 'https://facebook.com/phoenix.ge',  label: 'Facebook' },
    { icon: 'ri-instagram-line', href: 'https://instagram.com/phoenix.ge', label: 'Instagram' },
    { icon: 'ri-whatsapp-line',  href: 'https://wa.me/995599872020',       label: 'WhatsApp' },
  ],
};

export default function ContactPage() {
  const cms = useCMS('contact_page', DEFAULT);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const infoItems: typeof DEFAULT.info_items = cms.info_items ?? DEFAULT.info_items;
  const subjectOptions: typeof DEFAULT.form_subject_options = cms.form_subject_options ?? DEFAULT.form_subject_options;
  const socialLinks: typeof DEFAULT.social_links = cms.social_links ?? DEFAULT.social_links;

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as Record<string, string>);
    try {
      await fetch(cms.form_url, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: data.toString() });
      setSubmitted(true);
    } catch { setSubmitted(true); }
    finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-[#1C1C1C] overflow-hidden">
        <div className="absolute inset-0">
          <img src={cms.hero_image} alt={cms.hero_image_alt} className="w-full h-full object-cover object-top opacity-20" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1C1C1C] via-[#1C1C1C]/90 to-[#1C1C1C]/60"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-8 md:px-14">
          <span className="inline-block text-[10px] font-bold tracking-[0.35em] uppercase text-[#ec3145] mb-4">{cms.hero_label}</span>
          <h1 className="text-4xl md:text-6xl font-bold text-white tracking-tight mb-5 leading-tight">{cms.hero_heading}</h1>
          <p className="text-white/50 text-base md:text-lg max-w-xl leading-relaxed">{cms.hero_subtext}</p>
        </div>
      </section>

      {/* Info cards */}
      <section className="bg-[#F5F2EE] py-12">
        <div className="max-w-7xl mx-auto px-8 md:px-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {infoItems.map((item) => (
              <a key={item.label} href={item.href} target={item.href.startsWith('http') ? '_blank' : undefined} rel="noopener noreferrer"
                className="group bg-white p-6 flex flex-col gap-3 hover:border-[#ec3145] border border-transparent transition-all duration-300 cursor-pointer">
                <div className="w-10 h-10 flex items-center justify-center bg-[#ec3145]/8 group-hover:bg-[#ec3145] transition-colors duration-300">
                  <i className={`${item.icon} text-[#ec3145] group-hover:text-white transition-colors duration-300`}></i>
                </div>
                <div>
                  <p className="text-[10px] font-bold tracking-[0.25em] uppercase text-[#1C1C1C]/30 mb-1">{item.label}</p>
                  <p className="text-sm font-bold text-[#1C1C1C] group-hover:text-[#ec3145] transition-colors duration-300">{item.value}</p>
                  <p className="text-xs text-[#1C1C1C]/40 mt-0.5">{item.sub}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Form + Map */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-8 md:px-14">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 xl:gap-20">
            {/* Form */}
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-[#1C1C1C] mb-2">{cms.form_heading}</h2>
              <p className="text-sm text-[#1C1C1C]/45 mb-8 leading-relaxed">{cms.form_subtext}</p>
              {submitted ? (
                <div className="bg-[#F5F2EE] p-10 text-center">
                  <div className="w-14 h-14 rounded-full bg-[#ec3145]/10 flex items-center justify-center mx-auto mb-4">
                    <i className="ri-check-line text-2xl text-[#ec3145]"></i>
                  </div>
                  <h3 className="text-lg font-bold text-[#1C1C1C] mb-2">{cms.form_success_title}</h3>
                  <p className="text-sm text-[#1C1C1C]/50">{cms.form_success_text}</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="flex flex-col gap-5">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                    <div>
                      <label className="block text-[10px] font-bold tracking-[0.2em] uppercase text-[#1C1C1C]/40 mb-2">{cms.form_label_name}</label>
                      <input type="text" name="name" required placeholder={cms.form_placeholder_name} className="w-full border border-[#1C1C1C]/12 bg-[#F5F2EE] px-4 py-3 text-sm text-[#1C1C1C] placeholder-[#1C1C1C]/30 focus:outline-none focus:border-[#ec3145] transition-colors duration-200" />
                    </div>
                    <div>
                      <label className="block text-[10px] font-bold tracking-[0.2em] uppercase text-[#1C1C1C]/40 mb-2">{cms.form_label_surname}</label>
                      <input type="text" name="surname" placeholder={cms.form_placeholder_surname} className="w-full border border-[#1C1C1C]/12 bg-[#F5F2EE] px-4 py-3 text-sm text-[#1C1C1C] placeholder-[#1C1C1C]/30 focus:outline-none focus:border-[#ec3145] transition-colors duration-200" />
                    </div>
                  </div>
                  <div>
                    <label className="block text-[10px] font-bold tracking-[0.2em] uppercase text-[#1C1C1C]/40 mb-2">{cms.form_label_email}</label>
                    <input type="email" name="email" required placeholder={cms.form_placeholder_email} className="w-full border border-[#1C1C1C]/12 bg-[#F5F2EE] px-4 py-3 text-sm text-[#1C1C1C] placeholder-[#1C1C1C]/30 focus:outline-none focus:border-[#ec3145] transition-colors duration-200" />
                  </div>
                  <div>
                    <label className="block text-[10px] font-bold tracking-[0.2em] uppercase text-[#1C1C1C]/40 mb-2">{cms.form_label_phone}</label>
                    <input type="tel" name="phone" placeholder={cms.form_placeholder_phone} className="w-full border border-[#1C1C1C]/12 bg-[#F5F2EE] px-4 py-3 text-sm text-[#1C1C1C] placeholder-[#1C1C1C]/30 focus:outline-none focus:border-[#ec3145] transition-colors duration-200" />
                  </div>
                  <div>
                    <label className="block text-[10px] font-bold tracking-[0.2em] uppercase text-[#1C1C1C]/40 mb-2">{cms.form_label_subject}</label>
                    <select name="subject" className="w-full border border-[#1C1C1C]/12 bg-[#F5F2EE] px-4 py-3 text-sm text-[#1C1C1C] focus:outline-none focus:border-[#ec3145] transition-colors duration-200 cursor-pointer">
                      <option value="">{cms.form_subject_placeholder}</option>
                      {subjectOptions.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="block text-[10px] font-bold tracking-[0.2em] uppercase text-[#1C1C1C]/40 mb-2">{cms.form_label_message}</label>
                    <textarea name="message" required rows={5} maxLength={500} placeholder={cms.form_placeholder_message} className="w-full border border-[#1C1C1C]/12 bg-[#F5F2EE] px-4 py-3 text-sm text-[#1C1C1C] placeholder-[#1C1C1C]/30 focus:outline-none focus:border-[#ec3145] transition-colors duration-200 resize-none" />
                    <p className="text-[10px] text-[#1C1C1C]/25 mt-1">მაქსიმუმ 500 სიმბოლო</p>
                  </div>
                  <button type="submit" disabled={submitting} className="inline-flex items-center justify-center gap-2 bg-[#ec3145] text-white font-bold text-[11px] tracking-[0.2em] uppercase px-8 py-4 hover:bg-[#c9283a] transition-colors duration-300 cursor-pointer whitespace-nowrap disabled:opacity-60">
                    {submitting ? (<><i className="ri-loader-4-line animate-spin"></i> {cms.form_btn_loading}</>) : (<><i className="ri-send-plane-line"></i> {cms.form_btn_label}</>)}
                  </button>
                </form>
              )}
            </div>

            {/* Map + hours + social */}
            <div className="flex flex-col gap-6">
              {/* Map */}
              <div className="w-full overflow-hidden" style={{ height: '380px' }}>
                <iframe src={cms.map_embed_url} width="100%" height="100%" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title={cms.map_heading}></iframe>
              </div>

              {/* Hours + social */}
              <div className="bg-[#F5F2EE] p-6 md:p-8">
                <h3 className="text-[10px] font-bold tracking-[0.3em] uppercase text-[#1C1C1C]/35 mb-5">{cms.map_hours_heading}</h3>
                <div className="flex flex-col gap-3">
                  <div className="flex items-center justify-between py-2 border-b border-[#1C1C1C]/6">
                    <span className="text-sm text-[#1C1C1C]/60">{cms.map_hours_label_weekdays}</span>
                    <span className="text-sm font-semibold text-[#1C1C1C]">{cms.map_hours_weekdays}</span>
                  </div>
                  <div className="flex items-center justify-between py-2 border-b border-[#1C1C1C]/6">
                    <span className="text-sm text-[#1C1C1C]/60">{cms.map_hours_label_saturday}</span>
                    <span className="text-sm font-semibold text-[#1C1C1C]">{cms.map_hours_saturday}</span>
                  </div>
                  <div className="flex items-center justify-between py-2">
                    <span className="text-sm text-[#1C1C1C]/60">{cms.map_hours_label_sunday}</span>
                    <span className="text-sm font-semibold text-[#1C1C1C]/30">{cms.map_hours_sunday}</span>
                  </div>
                </div>

                {socialLinks.length > 0 && (
                  <div className="mt-6 pt-5 border-t border-[#1C1C1C]/8">
                    <p className="text-[10px] font-bold tracking-[0.25em] uppercase text-[#1C1C1C]/30 mb-3">{cms.social_heading}</p>
                    <div className="flex items-center gap-3">
                      {socialLinks.map((s) => (
                        <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer"
                          className="w-9 h-9 border border-[#1C1C1C]/12 flex items-center justify-center text-[#1C1C1C]/40 hover:border-[#ec3145] hover:text-[#ec3145] transition-all duration-300 cursor-pointer"
                          aria-label={s.label}>
                          <i className={`${s.icon} text-sm`}></i>
                        </a>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
